// src/pages/procurement/components/DocNumberCell.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Copy, Check } from 'lucide-react';
import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';
import tb from './ProcurementTable.module.css';

// "#NUMBER" link + copy button, mirroring the Order Number cell of OrderListPage.
const DocNumberCell = ({ number, to }) => {
  const { copy, isCopied } = useCopyToClipboard();
  if (!number) return <span className={tb.naText}>—</span>;
  const copied = isCopied(number);

  return (
    <div className={tb.orderNumberCell}>
      <Link to={to} className={tb.orderNumber} onClick={(e) => e.stopPropagation()}>
        #{number}
      </Link>
      <button
        type="button"
        className={tb.copyButton}
        onClick={(e) => { e.stopPropagation(); copy(number, number); }}
        title={copied ? 'Copied!' : 'Copy'}
      >
        {copied ? <Check size={12} /> : <Copy size={12} />}
      </button>
    </div>
  );
};

export default DocNumberCell;
